import { useState } from "react";
import { FiX } from "react-icons/fi";
import CommentsEditor from "../CommentsEditor";
import Button from "../ui/Button";

export default function CommentsEditorModal({onClose, uid, elementType='asset'}) {
    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l'>
            <div className='flex justify-between py-2 px-4 items-center'>
                <span className='text-white text-lg font-bold'>Comments</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <div className='flex-1 overflow-hidden'>
                <CommentsEditor uid={uid} elementType={elementType} />
            </div>
        </div>
    )
}